import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import { FinsightEntityField } from 'shared';

import { FieldEditorSection } from '../types/FieldEditorSection';
import { InputArea } from './InputArea';

export function FieldTypeSelector({ field, setField }: FieldEditorSection) {
  return (
    <InputArea
      name="Type"
      description={`The field type determines the kind of data that can be stored in this field.
String, Number, Boolean, Object, Date all work according to regular javascript rules.
However, there are a few extra types that Finsight supports:
- Enum: A field that can only take on a limited set of values (array of any regular javascript types)
- Entity: A field that references another entity. At the lowest level this is a string representation of the entity id. However, almost always it will be "displayed" as an object.
- Computed: A field that is calculated based on other fields. This is similar to the =SUM() functions in Excel.
- Image: A field that stores an image URL and displays the image (with optional icon or emoji).
- File: A field that stores a file URL and uses the file picker and URL entry only (no icon or emoji).`}
    >
      <TextField
        fullWidth
        label="Type"
        select
        value={field.type}
        onChange={(e) =>
          setField({
            ...field,
            type: e.target.value as FinsightEntityField['schema']['type'],
          })
        }
      >
        <MenuItem value="string">String</MenuItem>
        <MenuItem value="number">Number</MenuItem>
        <MenuItem value="boolean">Boolean</MenuItem>
        <MenuItem value="object">Object</MenuItem>
        <MenuItem value="date">Date</MenuItem>
        <MenuItem value="enum">Enum</MenuItem>
        <MenuItem value="entity">Entity</MenuItem>
        <MenuItem value="computed">Computed</MenuItem>
        <MenuItem value="image">Image</MenuItem>
        <MenuItem value="file">File</MenuItem>
      </TextField>
    </InputArea>
  );
}
